import axios from 'axios'
import endpoints from '@/api/endpoints'
import _ from 'lodash'

export default {
  async getVehiclesForDivision (divID) {
    return axios.get(endpoints.vehicles + '?division=' + divID).then((response) => {
      return _.orderBy(response.data, 'number')
    })
  },
  async getVehicles () {
    return axios.get(endpoints.vehicles).then((response) => {
      return _.orderBy(response.data, 'number')
    })
  },
  async getVehicle (itemID) {
    return axios.get(endpoints.vehicles + itemID + '/').then((response) => {
      return response.data
    })
  },
  async updateVehicle (item) {
    return axios.patch(endpoints.vehicles + item.id + '/', item).then((response) => {
      return response.data
    })
  },
  async newVehicle (item) {
    return axios.post(endpoints.vehicles, item).then((response) => {
      return response.data
    })
  }
}
